import { GetLoadable } from '../loader';
let exported = [
    'toggleExpandedForAll',
    'getTreeFromFlatData',
    'getNodeAtPath',
    'changeNodeAtPath',
    'walk',
    'map',
    'VLTheme'
];
let loader = ()=>null;
// #if process.env.UIX_CHUNKED === 'true'
loader = ()=>{
    return import(/* webpackChunkName: 'stree' */ './loadTreeChunk');
};
const Tree = GetLoadable(loader);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import Tree from './loadTreeChunk'
// import {
//   toggleExpandedForAll,
//   getTreeFromFlatData,
//   getNodeAtPath,
//   changeNodeAtPath,
//   walk,
//   map,
//   VLTheme,
// } from './loadTreeChunk'
// exported = {
//   toggleExpandedForAll,
//   getTreeFromFlatData,
//   getNodeAtPath,
//   changeNodeAtPath,
//   walk,
//   map,
//   VLTheme,
// }
// #endif
export const SortableTree = Tree;
export const exportedTree = {
    names: exported,
    loader
};
